import { IMemberPosition } from '@/core/interfaces/member-position.interface';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class EdMembersConnectedListComponent extends Vue {
  
  @Prop() readonly params: any;

  get members() {
    return this.params.members;
  }

  get prefix() {
    return this.params.prefix;
  }

}